import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import CartDrawer from "@/components/layout/CartDrawer";
import { CartProvider } from "@/lib/cart";
import Home from "@/pages/Home";
import Journal from "@/pages/Journal";
import Article from "@/pages/Article";
import Rituals from "@/pages/Rituals";
import RitualDetail from "@/pages/RitualDetail";
import Shop from "@/pages/Shop";
import Product from "@/pages/Product";
import Library from "@/pages/Library";
import Philosophy from "@/pages/Philosophy";
import Quiz from "@/pages/Quiz";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import RequireAdmin from "@/components/admin/RequireAdmin";
import NotFound from "@/pages/NotFound";

function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function Chrome({ children }) {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  if (isAdmin) return <>{children}</>;
  return (
    <>
      <Header />
      <main>{children}</main>
      <Footer />
      <CartDrawer />
    </>
  );
}

function App() {
  return (
    <div className="App" data-testid="app-root">
      <HelmetProvider>
        <BrowserRouter>
        <CartProvider>
          <ScrollToTop />
          <Chrome>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/journal" element={<Journal />} />
              <Route path="/journal/:slug" element={<Article />} />
              <Route path="/rituals" element={<Rituals />} />
              <Route path="/rituals/:slug" element={<RitualDetail />} />
              <Route path="/shop" element={<Navigate to="/rituals/rest" replace />} />
              <Route path="/shop/:slug" element={<Product />} />
              <Route path="/library" element={<Library />} />
              <Route path="/philosophy" element={<Philosophy />} />
              <Route path="/quiz" element={<Quiz />} />
              <Route path="/checkout/success" element={<CheckoutSuccess />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin"
                element={
                  <RequireAdmin>
                    <AdminDashboard />
                  </RequireAdmin>
                }
              />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Chrome>
          <Toaster
            position="bottom-center"
            toastOptions={{
              style: {
                background: "#1C1B1A",
                color: "#F7F5F0",
                border: "none",
                borderRadius: 0,
                fontFamily: "Outfit, sans-serif",
                fontSize: "0.78rem",
                letterSpacing: "0.12em",
                textTransform: "uppercase",
              },
            }}
          />
        </CartProvider>
      </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
